import React from 'react'
import styled from 'styled-components'

import { screenSize } from 'styles/shared'

const NoDataValue = ({ className }: {className?: string}) => (
  <S.Container className={className}>
    <span>No Data</span>
  </S.Container>
)

export default NoDataValue

const S = {
  Container: styled.div`
    display: flex;
    align-items: center;
    white-space: nowrap;
  `,
  Img: styled.img`
    margin-left: 5px;
    @media ${screenSize.medium} {
      width: 16px;
      height: 16px;
      margin-left: 2px;
    }
  `
}
